<template>
  <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
    <v-card height="100%">
      <v-toolbar dark color="blue">
        <v-btn icon dark @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Políticas del SGI</v-toolbar-title>
      </v-toolbar>

      <iframe :src="ruta" width="100%" :height="height"></iframe>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: (vm) => ({
    extension: ".pdf",
    // ruta:
    //   "http://192.168.11.201/intranet/calidad/Formularios/PDF's/EI 090.pdf#zoom=100",
    //ruta: "https://api.icssa.com.ar/SGI/Documentos/EI 002.pdf",
    ruta: `https://api.icssa.com.ar/SGI/Documentos/EI 002.pdf?${Math.random()}`,
    height: "100%",
    visible: true,
  }),

  computed: {
    show: {
      get() {
        // if (this.codigo != "") {
        //   this.ruta =
        //     "https://api.icssa.com.ar/SGI/Documentos/" + this.codigo + ".pdf";
        // }
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.visible = false;
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
  },
};
</script>
